export default "__VITE_ASSET__503cdcad__"